import {Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {RegistriesService} from '../../service';
import {AccessJson} from '@amlCore/models';
import {CheckDictEnum, RegistriesAccessEnum} from '@amlCore/enums';
import {AlertPanelComponent, AlertPanelService, AlertService} from '@amlCore/components';
import {TableReactiveUrlController} from '@amlCore/tableReactive';
import {Utils} from '@amlCore/utils';
import {IDataResponse} from '@amlCore/interfaces';
import {
  TableService,
  UserService,
  VisitedService
} from '@amlCore/services';
import {ConsolidatedInfoItem} from "../../model/consolidated/consolidatedInfoList.model";
import {ConsolidatedFilter} from "../../../core/models/consolidatedFilter.model";
import {AlertModalComponent, ConfirmComponent, InputFileComponent} from "../../../core";
import {DictImportResult} from "../../model/dictImportResult.model";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {finalize, takeUntil} from "rxjs/operators";
import {MvkInfoList, TerroristFile} from "../../model";

@Component({
  selector: 'app-registry-consolidated-info-list',
  templateUrl: './consolidated-info-list.component.html'
})
export class ConsolidatedInfoListComponent extends TableReactiveUrlController implements OnInit, OnDestroy {

  isShowVisited = true;
  isAll = false;
  isLoaded = false;
  loadCheckList = {};
  @ViewChild('alertObjCheck', {static: false}) alertObjToCheck: AlertPanelComponent;

  constructor(private readonly regSrv: RegistriesService,
              private readonly userSrv: UserService,
              private readonly modalService: NgbModal,
              protected readonly alertSrv: AlertService,
              protected readonly alertPanelSrv: AlertPanelService,
              protected readonly activatedRoute: ActivatedRoute,
              protected readonly visitedService: VisitedService,
              protected readonly tableService: TableService,
              protected readonly router: Router) {
    super(router, activatedRoute, visitedService, tableService, { sort: 'sysRegDate', dir: 'DESC'});
  }

  public dataList: ConsolidatedInfoItem[] = [];
  public access: AccessJson;

  ngOnInit() {
    this.access = this.userSrv.getAccess(RegistriesAccessEnum.QREF_CONSOLIDATED);
    this.activatedRoute.queryParams.subscribe((data: ConsolidatedFilter) => {
      this.loadList(this.syncParams(data));
    });
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  public getFilterObject(data): ConsolidatedFilter {
    const filter = this.tableService.getFilterSubject(data);
    return this.getFilterPlanObject(filter) as ConsolidatedFilter;
  }

  public onPageChange(params: ConsolidatedFilter) {
    this.navigate({...params, ...this.getParams(this.filter)});
  }

  private customSearch() {
    const params = this.getSearchPage(this.filter) as ConsolidatedFilter;
    params['dir'] = 'ASC';
    params['sort'] = 'idSubject';
    params['isAll'] = true;
    const urlParam = {};
    for (const key in params) {
      if (params[key] || typeof params[key] === "number") {
        urlParam[key] = params[key];
      }
    }
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigateByUrl('registries/consolidatedList?q=' + Utils.encodeJSONBase64(urlParam));
  }

  // @override
  public onSearch() {
    this.customSearch();
  }

  // @override
  public onFilter() {
    this.customSearch();
  }

  //обработка результата импорта
  public onAfterImport(result: any) {
    const data = result.data as DictImportResult;
    let comp = result.comp as InputFileComponent;
    if(!data?.success){
        comp.reset();
        this.alertObjToCheck.open(this.alertPanelSrv.getErrorMsg(data.error, true, 10000));
    } else {
      comp.reset();
      this.loadList();
      this.alertObjToCheck.open(this.alertPanelSrv.getSuccessMsg(
        `Успешно импортирован ${data.fileName} от ${data.dictDate}, количество записей ${data.count}.`, true, 10000));

    }
  }

  public onImportError(error: string) {
    if(error?.includes("Некорректное имя файла")) {
      this.alertSrv.error(`Имя перечня не корректно!<br>Имя перечня должно быть "Сводный перечень СБ ООН (англоязычная версия).xml" или "Сводный перечень СБ ООН (русскоязычная версия).xml"`);
    } else {
      this.alertSrv.error(error);
    }
  }

  public loadList(params?: ConsolidatedFilter) {
    const queryParams = this.getParams(params);
    this.regSrv.getConsolidatedFullInfoList(queryParams).subscribe((data: IDataResponse<ConsolidatedInfoItem>) => {
      this.dataList = data.content;
      this.total = data.totalSize;
      this.scrollRun();
    });
  }

  public showSubjList(item: ConsolidatedInfoItem) {
    if(this.isRowInactive(item)) {
      const modal = this.modalService.open(AlertModalComponent);
      modal.componentInstance.text = "Просмотр списка фигурантов перечня возможен только по действующему (последнему загруженному) перечню.";
      return;
    }
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigate([`registries/consolidatedList/${item.language}/${item.id}`]);
  }

  public remove($event, item: ConsolidatedInfoItem) {
    this.isLoaded = null;
    this.regSrv.removeFile('/api/v1/cls/extter/consolidated/remove', {id: item.id})
      .pipe(finalize(() => this.isLoaded = true)).subscribe(data => {
      this.alertObjToCheck.open(this.alertPanelSrv.getSuccessMsg(
        `Запись ${item.fileName} удалена!`, true, 10000));
      this.loadList();
    });
  }

  /**
   * Проверка по факторам риска
   * @param item - элемент проверки
   */
  public checkRiskFactor(item: ConsolidatedInfoItem) {
    this.regSrv.doCheckRiskFactor(item, CheckDictEnum.CONSOLIDATED, this.loadCheckList, this.alertObjToCheck, this.afterCheck.bind(this));
  }


  private afterCheck(item: TerroristFile, data: any): void {
    if(data.checkDate) {
      const lastCheckedItem = this.dataList.find(d => d.lastChecked && d.id != item.id);
      if(lastCheckedItem){
        lastCheckedItem.lastChecked = false;
      }
    }
  }

  isRowInactive(item: ConsolidatedInfoItem): boolean{
    return !item.isActual && !item.lastChecked;
  }

  ngOnDestroy() {
    this.checkScrollOptions();
  }

}
